import {useEffect, useMemo} from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon/FuseSvgIcon';
import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {
  CPaymentLinkStatuses,
  PaymentLinkUtm,
} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import PaymentLinkV2Promo from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Promo/PaymentLinkV2Promo';
import {usePaymentLinkTrackers} from '@/dataSource/src/api/payment-link/trackers';

import './styles';

interface PaymentLinkErrorProps {
  isNotFoundError?: boolean;
  paymentLinkId?: string;
}

export const PaymentLinkV2Error = ({
  isNotFoundError = false,
  paymentLinkId,
}: PaymentLinkErrorProps) => {
  const {t} = useTranslation();

  const title = useMemo(
    () =>
      isNotFoundError
        ? t('payment_link.not_found.title')
        : t('payment_link.error.title'),
    [isNotFoundError, t],
  );

  const description = useMemo(
    () =>
      isNotFoundError
        ? t('payment_link.not_found.description')
        : t('payment_link.error.description'),
    [isNotFoundError, t],
  );

  const {trackViewRequestMoneyInvalidLink} = usePaymentLinkTrackers();

  useEffect(() => {
    trackViewRequestMoneyInvalidLink({
      id: paymentLinkId,
      status: isNotFoundError
        ? CPaymentLinkStatuses.NOT_VALID
        : CPaymentLinkStatuses.ERROR,
      receiver_user: {
        id: '',
        name: '',
      },
      link_consumed: false,
      single_payment: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="payment-link-v2-error-background">
      <Box className="payment-link-v2-error-container">
        <PaymentLinkLogo />

        <Box className="payment-link-v2-error-hero">
          <Box className="payment-link-v2-error-badge">
            <FuseSvgIcon
              size={24}
              className="payment-link-v2-error-badge-icon">
              heroicons-outline:information-circle
            </FuseSvgIcon>
          </Box>

          <Box className="payment-link-v2-error-text">
            <Typography
              component="h1"
              className="payment-link-v2-error-title">
              {title}
            </Typography>
            <Typography className="payment-link-v2-error-subtitle">
              {description}
            </Typography>
          </Box>
        </Box>

        <PaymentLinkV2Promo
          utmCampaign={PaymentLinkUtm.Campaign.Unknown}
          utmMedium={PaymentLinkUtm.Medium.Invalid}
        />
      </Box>
    </section>
  );
};
